/**
  * @class meleMap_rectangle
  * @description
  *
  * # Purpose
  * Implaments RECTANGLE shape
  *
  * # Use
  *
  * # Implementation notes
  *
  */

import meleMap_shape from '../meleMap_shape.js'
const melemap_lib = require('../meleMap_lib.js')

export default class meleMap_rectangle extends meleMap_shape {
  static shape() { return 'R' }

  redrawShape() {
    if(this._points.length<2) { return this.deleteShape() }

    const points = [this._points[0], this._points[1]]
    if(this._shape) {
      this._shape.setBounds(points)
    }else {
      this._shape = L.rectangle(points, { pane: this._props.pane || melemap_lib.DEFAULT_PANE }).addTo(this._map)
    }

    this.configureShape()
  }

  calculateCenter() {
    if(this._points.length<2 || !this._shape) return(this._center = null)
    return this._center = melemap_lib.intermediatePoint(this._points[0], this._points[1], 0.5)
  }

  shape() {
    return 'R,'+this._points.slice(0, 2).map(point=>melemap_lib.point2geohash(point)).join(',')
  }

  addPoint(point) {
    if(this._points.length>=2) { this._points=[] }
    this._points.push(point)
    delete this._center
    this.redrawShape()
    this.redrawMarker()

    // prepare guiding rectangle if we have just one point
    if(this._points.length==1) {
      this._guide = L.rectangle([this._points[0], this._points[0]], { pane: melemap_lib.DRAW_PANE }).addTo(this._map)
      this._guide._path.setAttribute('marker', 'guide')
    }else if(this._guide) {
      this._map.removeLayer(this._guide)
      this._guide = null
    }
  }

  guide(point) {
    if(this._guide) {
      const last_point = this._points[this._points.length-1]
      if(!point) point = last_point
      this._guide.setBounds([last_point, point])
    }
  }
} // class meleMap_rectangle
